module.exports = __webpack_public_path__ + "img/juju_logo_eng.95c61846.svg";